<template>
    <div id="content">
        <div class="inner">
            <add-button v-if="$route.name === 'deviceTypeEvaluationsList' && $_createActionAllowed"
                        :title="'Přidat určení typu zařízení' | translate"
                        route-name="deviceTypeEvaluationNew">
            </add-button>
            <h1 v-translate>Určení typů zařízení</h1>
        </div>
        <div class="responsiveTabs">
            <ul class="tabs">
                <li :class="{'r-tabs-state-active': $route.name === 'deviceTypeEvaluationsList'}">
                    <a @click.stop="$router.push({name: 'deviceTypeEvaluationsList'})" v-translate>Seznam</a>
                </li>
                <li :class="{'r-tabs-state-active': $route.name === 'deviceTypeEvaluationsTester'}">
                    <a @click.stop="$router.push({name: 'deviceTypeEvaluationsTester'})" v-translate>Testovat</a>
                </li>
            </ul>
        </div>
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"

export default {
    name: "DeviceTypeEvaluationsContainer",
    mixins: [listActions],
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypeEvaluations/DeviceTypeEvaluationsContainer.vue